<template>
  <span class="inline-edit">
    <span
		v-if="!isEditing"
		@click="startEdit"
		class="inline-edit__text"
		:class="{ 'inline-edit__text--empty': !value }"
	>
      {{ displayText }}
    </span>
    <v-textarea
		v-else
		:value="editValue"
		@input="updateEditValue"
		dense
		auto-grow
		rows="1"
		class="inline-edit__input"
		ref="input"
		type="text"
		@blur="onBlur"
		@keyup.enter.ctrl="onBlur"
		@keydown.esc.stop.prevent="cancelEdit"
		hint="Ctrl+Enter per salvare"
	/>
  </span>
</template>

<script>
export default {
	name: "InlineEdit",
	props: {
		value: {
			type: String,
			default: ""
		},
		placeholder: {
			type: String,
			default: "Click to edit"
		}
	},
	data() {
		return {
			isEditing: false,
			editValue: ""
		};
	},
	computed: {
		displayText() {
			return this.value || this.placeholder;
		}
	},
	methods: {
		updateEditValue(value) {
			// this.$log.debug("updateEditValue:" + value);
			this.editValue = value;
		},

		startEdit() {
			this.editValue = this.value;
			this.isEditing = true;
			this.$emit("start-edit");
			this.$nextTick(() => {
				this.$refs.input.focus();
			});
		},
		onBlur() {
			this.isEditing = false;
			this.$emit("input", this.editValue);
			this.$emit("end-edit", { value: this.editValue, canceled: false });
		},
		cancelEdit() {
			this.isEditing = false;
			this.editValue = this.value;
			this.$emit("input", this.value);
			this.$emit("end-edit", { value: this.value, canceled: true });
		}
	}
};
</script>

<style scoped>
.inline-edit {
	display: inline-block;
}

.inline-edit__text {
	cursor: pointer;
	padding: 2px 4px;
}

.inline-edit__text:hover {
	background-color: rgba(0, 0, 0, 0.05);
	border-radius: 3px;
}

.inline-edit__text--empty {
	color: #999;
	font-style: italic;
}

/* Adjust v-textarea styling */
.inline-edit__input {
	display: inline-block;
	margin: 0;
	padding: 0;
}

/* Remove the default vuetify field margin */
.inline-edit__input ::v-deep .v-input__control {
	min-height: unset;
}

.inline-edit__input ::v-deep .v-input__slot {
	margin-bottom: 0;
	min-height: unset;
}
</style>
